export default __webpack_public_path__ + "static/media/logo138x75white.1ae21dd9.png";